module.exports = __webpack_public_path__ + "static/media/rafting.459d2f6f.jpg";